import { Box, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

export const ActivitiesEmptyGhostRow: FC = () => {
	const { palette, radii, spacingTokens, iconBoxSize, activity } = useTheme();
	const ghost = palette.grey[100];

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={spacingTokens.md}
			sx={{ opacity: 0.5 }}
		>
			<Box
				width={iconBoxSize.md}
				height={iconBoxSize.md}
				flexShrink={0}
				bgcolor={ghost}
				borderRadius={radii.lg}
			/>
			<Stack flex={1} gap={spacingTokens.sm}>
				<Box
					width="35%"
					height={activity.ghostRow.overlineHeight}
					bgcolor={ghost}
					borderRadius={radii.full}
				/>
				<Box
					width="70%"
					height={activity.ghostRow.titleHeight}
					bgcolor={ghost}
					borderRadius={radii.full}
				/>
			</Stack>
		</Stack>
	);
};
